<template>
  <div >
    <el-dialog title="收款信息" :visible.sync="openCollectionList" width="780px">
      <div slot="title" class="dialog-title">
        {{title}}
      </div>
      <div class="back-color-fff bank-list-table" >
        <el-table :data="collectionTable" style="width: 100%;margin-bottom: 10px; "  border tooltip-effect="light" stripe @row-click="rowClickHandle" highlight-current-row max-height="400" wid>
          <el-table-column align="center" width="50" label="选择">
            <template slot-scope="scope">
              <el-radio class="radio" v-model="selectCode" :label="scope.row.guid">
                <span></span>
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :label="streamType === '1'?'收款日期':'付款日期'" width="120" header-align="left" align="left">
            <template slot-scope="scope">{{ scope.row.receiveDate | getDate }}</template>
          </el-table-column>
          <el-table-column prop="templateName" label="收款金额(元)" width="120" show-overflow-tooltip header-align="right" align="right">
            <template slot-scope="scope">{{ scope.row.receiveAmount | numDigit }}</template>
          </el-table-column>
          <el-table-column prop="taskTotal" label="支付方" show-overflow-tooltip header-align="left" align="left" width="220">
            <template slot-scope="scope">{{ scope.row.payTenantName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="templateName" label="收款方" show-overflow-tooltip header-align="left" align="left" width="220">
            <template slot-scope="scope">{{ scope.row.receiveTenantName || '-' }}</template>
          </el-table-column>
          <el-table-column v-if="paramCollection.streamType ==='1'" prop="templateName" label="收款方账户信息" show-overflow-tooltip header-align="left" align="left" width="160">
            <template slot-scope="scope">
              <div>{{ scope.row.accountType | accountTypeFilter }}</div>
              <div>{{ scope.row.bankName || '-' }}</div>
              <div>{{ scope.row.bankAccount || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="taskTotal" label="对应款项" width="120" show-overflow-tooltip header-align="left" align="left">
            <template slot-scope="scope">{{ getName(scope.row.correspondItem, '对应款项') }}</template>
          </el-table-column>
          <!-- <el-table-column prop="createTime" :label="streamType === '1'?'收款日期':'付款日期'" width="120" header-align="left" align="left">
            <template slot-scope="scope">{{ scope.row.receiveDate | getDate }}</template>
          </el-table-column>
          <el-table-column prop="templateName" label="收款金额(元)" width="120" show-overflow-tooltip header-align="right" align="right">
            <template slot-scope="scope">{{ scope.row.receiveAmount | numDigit }}</template>
          </el-table-column> -->
          <el-table-column prop="templateName" label="是否垫资款" show-overflow-tooltip header-align="left" align="left" width="80">
            <template slot-scope="scope">{{ scope.row.isCapitalAdvances | getIsInvoiceFirst }}</template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100, 200]"
          :current-page="page.pageIndex"
          :pager-count="5"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
      </el-pagination>
      </div>
      <div class="operte-btns">
        <div class="btn cancel" @click="openCollectionList = false">取消</div>
        <div class="btn submit" @click="submitCollection">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['paramCollection'],
  data() {
    return {
      collectionTable: [],
      messageData:{},
      openCollectionList: false,
      selectCode:'',
      checkBankObj: {},
      title:'',
      streamType:'' ,// 上游1 下游2
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
    };
  },
  created() {
    // !监听打开弹窗消息
    this.$root.$on('openCollectionList', (messageData) => {
      this.messageData=messageData
      this.streamType = messageData.streamType
      this.title = messageData.streamType === '1'?'上游收款信息':'下游付款信息'
      this.openCollectionList = true;
      this.selectCode = ''
      this.checkBankObj = {}
      this.getCollectionList(messageData);
    });
  },
  beforeDestroy() {
    this.$root.$off('openCollectionList');
  },
  methods: {
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getCollectionList(this.messageData)//获取阅读情况
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getCollectionList(this.messageData)//获取阅读情况
    },
    // 获取上游收款列表
    getCollectionList(messageData) {
      let self = this;
      let { form } = this;
      let param = {
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize,
        streamType: messageData.streamType,
        payTenantGuid: messageData.payTenantGuid,
        receiveTenantGuid: messageData.receiveTenantGuid,
        serviceTenantGuid:localStorage.guid,
        isSelect:'Y'
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/page-list`, param).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.collectionTable = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 选择收款信息
    submitCollection() {
      this.openCollectionList = false
      this.$emit('getCollectionInfo',this.checkBankObj)
    },
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter((item) => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
    rowClickHandle(row) {
      this.selectCode= row.guid;
      let item = this.collectionTable.find((item) => item.guid === row.guid);
      this.checkBankObj = item
      this.checkBankObj = row
    }
  },
};
</script>

<style scoped>
/deep/.el-dialog__header {
  border-bottom: 1px solid #d9d9d9;
}
/deep/.el-radio__label {
  padding-left: 0;
}
.operte-btns {
  background: #fff;
  margin-top: 4px;
  display: flex;
  justify-content: center;
  padding: 25px 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}

.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}

.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}
.dialog-title {
  width: 120px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
/deep/.bank-list-table .el-table {
  font-size: 12px;
  color: #212121;
}

/deep/.bank-list-table .el-table__body-wrapper tr, .bank-list-table .el-table__body td.el-table__cell {
  height: 40px;
}

/deep/.bank-list-table .el-table__body-wrapper tr td {
  border-right: 1px solid #D9D9D9;
}

/deep/.bank-list-table .el-table .el-table__cell {
  padding: 0px;
}

/deep/.bank-list-table .el-table th.el-table__cell {
  background-color: #F2F2F2;
  height: 32px;
  border-right: 1px solid #D9D9D9;
  border-top: 1px solid #D9D9D9;
}

/deep/.bank-list-table .el-table th.el-table__cell:last-child {
  border-right: none;
}
/deep/.bank-list-table .el-table th.el-table__cell:nth-last-child(2) {
  border-right: none;
}

/deep/.bank-list-table .el-table td.el-table__cell, .bank-list-table .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #D9D9D9;
}
</style>
